export default "__VITE_ASSET__2QT$jGR$__"